let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jFAe5")).then(() => parcelRequire('j281j'));